import React from 'react'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { theme } from '../theme'
import { StyledBox } from '../components/styledComponents/StyledItemComponents'

const sections = [
  {
    title: 'I. Prevederi generale',
    body: [
      'Platforma www.primusvest.ro este deținută și administrată de PRIMUSVEST SRL, J05/485/2016, CUI RO35750706, Sat Sârbești nr. 72, jud. Bihor.',
      'Acești Termeni și Condiții se pot actualiza fără notificare prealabilă; pentru fiecare comandă se aplică versiunea în vigoare la momentul plasării comenzii.',
      'Imaginile, descrierile și materialele multimedia au rol informativ. În caz de neconcordanțe evidente, prevalează confirmarea comercială transmisă clientului.',
      'Pentru suport comercial și operațional: office@primusvest.ro, +40 770 585 736.'
    ]
  },
  {
    title: 'II. Acceptarea condițiilor și contractul la distanță',
    body: [
      'Plasarea unei comenzi reprezintă acceptarea Termenilor și Condițiilor.',
      'Informațiile de pe site constituie invitație la ofertă; contractul se consideră încheiat după confirmarea comenzii de către vânzător.',
      'Primusvest poate refuza sau anula comenzi în caz de date eronate, suspiciune de fraudă, erori tehnice ori prețuri evident greșite.'
    ]
  },
  {
    title: 'III. Cont, date de identificare și utilizare platformă',
    body: [
      'Crearea contului necesită date corecte și complete. Clientul este responsabil pentru confidențialitatea datelor de acces.',
      'Sunt interzise comportamentele frauduloase, crearea de conturi multiple în scop abuziv și tentativele de compromitere a platformei.',
      'Produsele cu mențiunea „cu acumulator” funcționează pe acumulator, dar acumulatorii/accesoriile sunt incluse doar dacă este precizat explicit în descriere.'
    ]
  },
  {
    title: 'IV. Prețuri și modalități de plată',
    body: [
      'Prețurile sunt exprimate în RON. În interfața publică se afișează prețul final al produsului.',
      'Costul de transport nu este inclus în prețul produsului și se calculează separat la comandă.',
      'Modalitățile de plată disponibile sunt cele afișate la checkout (transfer bancar/proformă, plată în magazin, plată online cu cardul prin procesator autorizat).',
      'Factura fiscală se emite conform legislației în vigoare și poate fi transmisă fizic sau electronic.'
    ]
  },
  {
    title: 'V. Livrare',
    body: [
      'Livrarea se realizează pe teritoriul României, prin curier sau ridicare din magazinele fizice Primusvest.',
      'Produsele indisponibile imediat pot fi livrate la comandă, în funcție de termenul furnizorului.',
      'Comenzile mixte pot fi expediate în tranșe. Data de livrare este estimativă și depinde de disponibilitatea efectivă.',
      'Transportul standard este 35 lei/comandă, achitat de cumpărător.'
    ]
  },
  {
    title: 'VI. Retur și clienți persoane juridice',
    body: [
      'Pentru clienții persoane juridice nu se aplică dreptul legal de retragere de 14 zile prevăzut pentru consumatori.',
      'Returul pentru persoane juridice este acceptat exclusiv pentru neconformitate, livrare greșită sau alte situații expres convenite.',
      'Pentru clienții non-consumatori, Primusvest poate aplica condiții comerciale speciale de plată și livrare.'
    ]
  },
  {
    title: 'VII. Garanții, reclamații și produse OUTLET',
    body: [
      'Produsele comercializate beneficiază de garanție conform politicii producătorului și legislației aplicabile.',
      'Garanția se acordă pe baza documentelor fiscale și a condițiilor de utilizare/manipulare specificate de producător.',
      'Produsele din secțiunea OUTLET pot avea particularități comerciale (ex. ambalaj deteriorat, accesorii lipsă, urme de testare sau stoc vechi). Aceste aspecte trebuie verificate înainte de comandă.',
      'Pentru uneltele eligibile se pot aplica programe de garanție extinsă ale producătorilor (de ex. înregistrări pe portaluri oficiale).'
    ]
  },
  {
    title: 'VIII. Limitarea răspunderii',
    body: [
      'Primusvest nu garantează funcționarea neîntreruptă a platformei și nu răspunde pentru indisponibilități temporare cauzate de factori tehnici externi.',
      'Clientul utilizează site-ul pe propria răspundere; răspunderea vânzătorului este limitată, în condițiile legii, la valoarea comenzii aferente.',
      'Link-urile către site-uri terțe sunt furnizate pentru informare, fără asumarea conținutului sau serviciilor acelor site-uri.'
    ]
  },
  {
    title: 'IX. Forță majoră',
    body: [
      'Părțile nu răspund pentru neexecutarea obligațiilor cauzată de forță majoră, în condițiile legii.',
      'Partea care invocă forța majoră trebuie să notifice cealaltă parte în termen rezonabil și să furnizeze dovezi.',
      'Dacă evenimentul persistă, contractul poate înceta în condițiile prevăzute de legislația aplicabilă.'
    ]
  },
  {
    title: 'X. Legea aplicabilă și litigii',
    body: [
      'Relațiile contractuale sunt guvernate de legea română.',
      'Părțile vor încerca soluționarea amiabilă a disputelor înainte de sesizarea instanțelor competente.',
      'Consumatorii pot utiliza și mecanismele alternative de soluționare a litigiilor disponibile conform legislației.'
    ]
  }
]

const Termeni = () => {
  return (
    <Box sx={{ backgroundColor: theme.palette.secondary.main, padding: '40px 0' }}>
      <StyledBox>
        <Stack bgcolor={theme.palette.primary.main} p='30px' border='solid 1px' borderColor={theme.palette.borderColor.main} borderRadius='4px' spacing={3}>
          <Box>
            <Typography variant='h4' sx={{ fontSize: '22px', fontWeight: 700, marginBottom: '10px' }}>
              Termeni și condiții
            </Typography>
            <Typography variant='body1' sx={{ color: theme.palette.fontColor.medium }}>
              Document operațional sincronizat pentru fluxurile B2B Primusvest (transport, OUTLET, comandă la distanță, suport comercial).
            </Typography>
          </Box>
          <Divider />
          {sections.map((section) => (
            <Box key={section.title}>
              <Typography variant='h5' sx={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px' }}>
                {section.title}
              </Typography>
              <Stack spacing={1.5}>
                {section.body.map((paragraph) => (
                  <Typography key={paragraph} variant='body1' sx={{ color: theme.palette.fontColor.main, lineHeight: 1.7 }}>
                    {paragraph}
                  </Typography>
                ))}
              </Stack>
            </Box>
          ))}
        </Stack>
      </StyledBox>
    </Box>
  )
}

export default Termeni
